<div class="flex flex-col gap-5 w-full">

  <!-- Painel de progresso geral -->
  <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 p-6 flex flex-col gap-5">

    <div class="flex items-center justify-between flex-wrap gap-2">
      <div>
        <div class="flex items-center gap-2 flex-wrap">
          <h2 class="text-lg font-bold text-gray-800 dark:text-white">{{ progresso.nome }}</h2>
          <span class="flex items-center gap-1 text-xs font-medium text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-zinc-800 px-2 py-0.5 rounded-full">
            <i [class]="tipoConfig.icon"></i>{{ tipoConfig.label }}
          </span>
        </div>
        @if (progresso.descricao) {
          <p class="text-sm text-gray-500 dark:text-gray-400">{{ progresso.descricao }}</p>
        }
        @if (progresso.tipoMeta === 'PERCENTUAL_STATUS' && progresso.statusAlvo) {
          <p class="text-sm text-gray-500 dark:text-gray-400">Status alvo: <strong>{{ progresso.statusAlvo }}</strong></p>
        }
      </div>
      <p-tag [value]="labelDiasRestantes" [severity]="severidadeDias"/>
    </div>

    <!-- Percentual grande + barra -->
    <div class="flex flex-col gap-3">
      <div class="flex items-end justify-between">
        <div class="flex items-end gap-2">
          <span class="text-5xl font-black" [ngStyle]="{'color': corProgresso}">
            {{ progresso.percentualAtingido | number:'1.1-1' }}%
          </span>
          <span class="text-gray-400 dark:text-zinc-500 text-sm mb-2">da meta atingida</span>
        </div>
        <div class="text-right">
          <p class="text-[10px] text-gray-400 dark:text-zinc-500 uppercase tracking-widest">Notificações</p>
          <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ progresso.totalNotificacoes }}</p>
        </div>
      </div>
      <p-progressbar [value]="progresso.percentualAtingido"
                     [style]="{'height': '12px', 'border-radius': '6px'}"
                     [showValue]="false"/>
    </div>

    <!-- Cards de valores -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div class="rounded-xl p-4 bg-green-50 dark:bg-green-950/20 border border-green-200 dark:border-green-900">
        <p class="text-xs font-semibold text-green-600 dark:text-green-400 uppercase tracking-widest">{{ tipoConfig.labelAtingido }}</p>
        <p class="text-2xl font-bold text-green-700 dark:text-green-300 mt-1">
          {{ progresso.valorAtingido | metaValor:progresso.tipoMeta }}
        </p>
      </div>
      <div class="rounded-xl p-4 bg-gray-50 dark:bg-zinc-900 border border-gray-200 dark:border-zinc-700">
        <p class="text-[10px] font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-widest">{{ tipoConfig.labelMeta }}</p>
        <p class="text-2xl font-bold text-gray-700 dark:text-gray-200 mt-1">
          {{ progresso.valorMeta | metaValor:progresso.tipoMeta }}
        </p>
      </div>
      <div class="rounded-xl p-4 bg-red-50 dark:bg-red-950/20 border border-red-200 dark:border-red-900">
        <p class="text-[10px] font-semibold text-[#E41B2E] dark:text-red-400 uppercase tracking-widest">{{ tipoConfig.labelRestante }}</p>
        <p class="text-2xl font-bold text-[#E41B2E] dark:text-red-300 mt-1">
          {{ progresso.valorRestante | metaValor:progresso.tipoMeta }}
        </p>
      </div>
    </div>

    <!-- Período e status -->
    <div class="flex flex-wrap gap-4 pt-2 border-t border-gray-100 dark:border-zinc-800 text-sm text-gray-500 dark:text-gray-400">
      <span><i class="pi pi-calendar mr-1"></i>{{ progresso.dataInicio | date:'dd/MM/yyyy' }} – {{ progresso.dataFim | date:'dd/MM/yyyy' }}</span>
      <span class="flex gap-1 items-center flex-wrap">
        <i class="pi pi-tag mr-1"></i>
        @for (s of progresso.statusContribuintes; track s) {
          <span class="bg-red-50 dark:bg-red-950/30 text-[#E41B2E] dark:text-red-400 px-2 py-0.5 rounded-full text-xs font-medium">{{ s }}</span>
        }
      </span>
    </div>
  </div>

  <!-- Projeção -->
  @if (progresso.projecao) {
    <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 p-6 flex flex-col gap-4">
      <div class="flex items-center justify-between flex-wrap gap-2">
        <h3 class="text-xs font-semibold text-gray-400 dark:text-zinc-500 uppercase tracking-widest">Projeção</h3>
        <p-tag [value]="projecaoInfo.label" [icon]="projecaoInfo.icon" [severity]="projecaoInfo.severity"/>
      </div>

      @if (progresso.projecao.status === 'ATINGIDA') {
        <p class="text-sm text-gray-600 dark:text-gray-300">Parabéns! O valor já atingido supera a meta estabelecida para o período.</p>
      } @else if (progresso.projecao.status === 'ENCERRADA') {
        <p class="text-sm text-gray-600 dark:text-gray-300">O período da meta já terminou sem que o alvo fosse atingido.</p>
      } @else {
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <p class="text-[10px] text-gray-400 dark:text-zinc-500 uppercase tracking-widest">Ritmo médio atual</p>
            <p class="text-2xl font-bold text-gray-800 dark:text-white mt-1">{{ progresso.projecao.ritmoMedioAtual | metaValor:progresso.tipoMeta }} <span class="text-sm font-normal text-gray-400">/dia</span></p>
          </div>
          <div>
            <p class="text-[10px] text-gray-400 dark:text-zinc-500 uppercase tracking-widest">Projeção ao final do período</p>
            <p class="text-2xl font-bold mt-1" [ngStyle]="{'color': progresso.projecao.status === 'NO_CAMINHO' ? '#2563eb' : '#d97706'}">
              {{ progresso.projecao.projecaoFinal | metaValor:progresso.tipoMeta }}
              <span class="text-sm font-normal text-gray-400">({{ progresso.projecao.percentualProjetado | number:'1.0-0' }}%)</span>
            </p>
          </div>
          <div>
            <p class="text-[10px] text-gray-400 dark:text-zinc-500 uppercase tracking-widest">Ritmo necessário para bater a meta</p>
            <p class="text-2xl font-bold text-gray-800 dark:text-white mt-1">
              {{ progresso.projecao.ritmoNecessario | metaValor:progresso.tipoMeta }} <span class="text-sm font-normal text-gray-400">/dia</span>
            </p>
          </div>
        </div>
      }
    </div>
  }

  <!-- Seletor de dimensão -->
  <div class="flex items-center gap-3 flex-wrap">
    <span class="text-xs font-semibold text-gray-500 dark:text-gray-400 whitespace-nowrap">Agrupar por:</span>
    <p-selectbutton [options]="dimensoes" optionLabel="label" optionValue="value" size="small"
                     [ngModel]="dimensaoSelecionada" (onChange)="selecionarDimensao($event.value)"/>
    @if (chaveSelecionada) {
      <span class="flex items-center gap-2 bg-gray-100 dark:bg-zinc-800 rounded-full pl-3 pr-1 py-1 text-sm text-gray-700 dark:text-gray-200">
        Filtrado por: <strong>{{ chaveSelecionada }}</strong>
        <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" (onClick)="limparFiltro()"/>
      </span>
    }
  </div>

  <!-- Gráfico + grid por dimensão -->
  @if (grupoAtual.length > 0) {
    <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 p-4 flex justify-center">
      <div class="h-72 w-full max-w-2xl">
        <p-chart type="doughnut" [data]="chartData" [options]="chartOptions"
                 (onDataSelect)="onChartSelect($event)" [height]="'100%'"/>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
      @for (item of grupoAtual; track item.chave) {
        <button type="button"
                class="text-left bg-white dark:bg-black rounded-xl border p-4 flex flex-col gap-3 transition-colors cursor-pointer hover:border-gray-300 dark:hover:border-zinc-600"
                [class.border-gray-200]="chaveSelecionada !== item.chave"
                [class.dark:border-zinc-800]="chaveSelecionada !== item.chave"
                [ngStyle]="chaveSelecionada === item.chave ? {'border-color': corDe(item.chave)} : {}"
                (click)="selecionarGrupo(item.chave)">
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 rounded-full flex-shrink-0" [ngStyle]="{'background-color': corDe(item.chave)}"></div>
            <span class="font-semibold text-sm text-gray-800 dark:text-white leading-tight truncate">{{ item.chave }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <div class="flex justify-between text-xs text-gray-500 dark:text-gray-400">
              <span>{{ item.percentualDaMeta | number:'1.1-1' }}% da meta</span>
              <span>{{ item.quantidade }} NOT</span>
            </div>
            <p-progressbar [value]="item.percentualDaMeta"
                           [style]="{'height': '6px', 'border-radius': '3px'}"
                           [showValue]="false"/>
          </div>
          <p class="text-lg font-bold text-gray-800 dark:text-white">
            {{ item.valorContribuido | currency:'BRL':'symbol':'1.0-0' }}
          </p>
        </button>
      }
    </div>
  }

  <!-- Drill-down inline -->
  @if (chaveSelecionada) {
    <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 p-4 flex flex-col gap-3">
      <div class="flex items-center justify-between flex-wrap gap-2">
        <h3 class="text-sm font-semibold text-gray-600 dark:text-gray-300">
          Notificações — {{ chaveSelecionada }}
        </h3>
        @if (drillDownDesatualizado) {
          <button type="button" class="text-xs text-[#E41B2E] hover:underline" (click)="recarregarDrillDown()">
            <i class="pi pi-refresh mr-1"></i>dados atualizados — clique para recarregar
          </button>
        }
      </div>
      <p-table [value]="drillDownResultados" [loading]="drillDownLoading" [paginator]="true" [rows]="10"
               styleClass="p-datatable-sm">
        <ng-template #header>
          <tr>
            <th>Notificação</th>
            <th>Concessionária</th>
            <th>Status</th>
            <th>Fase</th>
            <th>Motivo</th>
            <th>Data</th>
            <th>Valor Atual</th>
          </tr>
        </ng-template>
        <ng-template #body let-item>
          <tr>
            <td>{{ item.numeroNotificacao }}</td>
            <td>{{ item.concessionaria }}</td>
            <td>{{ item.status }}</td>
            <td>{{ item.fase }}</td>
            <td>{{ item.motivo }}</td>
            <td>{{ item.dataNotificacao | date:'dd/MM/yyyy' }}</td>
            <td>{{ item.valorAtual | currency:'BRL':'symbol':'1.2-2' }}</td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr><td colspan="7" class="text-center text-gray-400 py-4">Nenhuma notificação encontrada para esse grupo.</td></tr>
        </ng-template>
      </p-table>
    </div>
  }

</div>
